export const Icon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#949494">
            <path d="M3,5h6l1,2h11v12H3V5z" />
        </svg>
    );
};
